// @flow
import React from 'react';
import styled from 'styled-components';
import { fonts } from 'bench-style-constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  width: 100%;
  background-color: transparent;
`;

const Title = styled.h1`
  font-family: ${fonts.circular};
  font-size: 24px;
  line-height: 24px;
  opacity: 0.5;
  margin: 10px 0;
`;

const Subtitle = styled.span`
  font-family: ${fonts.circular};
  font-size: 16px;
  opacity: 0.5;
`;

type NullStateProps = {
  title?: string,
  subtitle?: string,
};

const NullState = (props: NullStateProps) => (
  <Container>
    {props.title && <Title>{props.title}</Title>}
    {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
  </Container>
);

NullState.defaultProps = {
  title: null,
  subtitle: null,
};

export default NullState;
